/** 解析失敗動画アップロードの共通定数。 */

export const ERR_VIDEO_MAX_BYTES = 500 * 1024 * 1024
export const ERR_VIDEO_MAX_FILES = 5

export const isMp4File = (file: File): boolean => {
  const name = file.name.toLowerCase()
  return name.endsWith('.mp4')
}
